import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "homeOut" }
const _hoisted_2 = { class: "mainBox" }
const _hoisted_3 = { class: "mainCentr" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "titleMes" }
const _hoisted_6 = {
  key: 0,
  style: {"height":"31px","display":"flex","align-items":"center"}
}
const _hoisted_7 = { class: "videoItem" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onLoadeddata"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "cardType" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "typeMes" }
const _hoisted_16 = {
  key: 0,
  class: "typeDes"
}
const _hoisted_17 = { class: "typeContent" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "itemTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_search = _resolveComponent("page-search")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Footer1 = _resolveComponent("Footer1")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_search),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_row, { gutter: 48 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleList, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: _ctx.titlePer,
                  key: i,
                  style: {"margin-bottom":"40px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["cardTitle", item.jumpUrl?'cardTitlePointer':'']),
                      onClick: ($event: any) => (_ctx.openArt(item.jumpUrl))
                    }, [
                      _createElementVNode("span", _hoisted_5, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "carTitleIcon" }, null, -1)),
                        _createTextVNode(_toDisplayString(item.groupName), 1)
                      ]),
                      (item.jumpUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_el_icon, { class: "rightIcon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowRight)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_4)
                  ]),
                  _: 2
                }, 1032, ["span"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 48 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 24,
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (item.imageUrl&&!item.videoLoaded)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "video-image",
                            src: item.imageUrl,
                            alt: ""
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      _createElementVNode("video", {
                        class: "video-play",
                        controls: false,
                        autoplay: "autoplay",
                        muted: "muted",
                        loop: "loop",
                        onLoadeddata: ($event: any) => (_ctx.onVideoLoaded(item))
                      }, [
                        _createElementVNode("source", {
                          src: item.videoUrl,
                          type: "video/mp4"
                        }, null, 8, _hoisted_10),
                        _createElementVNode("source", {
                          src: item.videoUrl,
                          type: "video/ogg"
                        }, null, 8, _hoisted_11)
                      ], 40, _hoisted_9)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            gutter: 40,
            style: {"margin-top":"28px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: _ctx.typePer,
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["typeHead", item.jumpUrl?'typeHeadPointer':'']),
                        onClick: ($event: any) => (_ctx.openArt(item.jumpUrl))
                      }, [
                        (item.imageUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "typeIcon",
                              src: item.imageUrl,
                              alt: "logo"
                            }, null, 8, _hoisted_14))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.groupName), 1)
                      ], 10, _hoisted_13),
                      (item.groupDesc)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.groupDesc), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (one) => {
                              return (_openBlock(), _createBlock(_component_el_col, {
                                span: _ctx.artPer,
                                key: one.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "typeItem",
                                    onClick: ($event: any) => (_ctx.openArt(one.jumpUrl))
                                  }, [
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "itemCircle" }, null, -1)),
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(one.itemName), 1)
                                  ], 8, _hoisted_18)
                                ]),
                                _: 2
                              }, 1032, ["span"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["span"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Footer1)
  ], 64))
}